import { Input } from '../ui/Input';

interface SignupIdentityFieldsProps {
  name: string;
  nameError: string;
  onNameChange: (value: string) => void;
  userName: string;
  userNameError: string;
  onUserNameChange: (value: string) => void;
  disabled: boolean;
}

/** Display-name and username inputs, shown only on the sign-up tab. */
export const SignupIdentityFields = ({
  name,
  nameError,
  onNameChange,
  userName,
  userNameError,
  onUserNameChange,
  disabled,
}: SignupIdentityFieldsProps) => (
  <>
    <Input
      label="Display Name"
      type="text"
      value={name}
      onChange={(e) => onNameChange(e.target.value)}
      placeholder="Your name"
      error={nameError}
      success={name.trim().length >= 2 && !nameError}
      helperText="Your full name or preferred name"
      fullWidth
      required
      disabled={disabled}
    />

    <Input
      label="Username"
      type="text"
      value={userName}
      onChange={(e) => onUserNameChange(e.target.value)}
      placeholder="username"
      error={userNameError}
      success={userName.length >= 3 && !userNameError}
      helperText="Letters, numbers, and underscores only"
      fullWidth
      required
      disabled={disabled}
    />
  </>
);
